import React from 'react'
import { Spinner } from 'react-bootstrap'
import { MetricCardProps } from '../types'
import * as S from '../styles'

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  subtitle,
  change,
  icon,
  color = 'primary',
  loading = false
}) => {
  if (loading) {
    return (
      <S.MetricCardContainer>
        <S.LoadingSpinner>
          <Spinner animation="border" />
        </S.LoadingSpinner>
      </S.MetricCardContainer>
    )
  }

  return (
    <S.MetricCardContainer>
      <div className="d-flex align-items-start justify-content-between">
        <div className="flex-grow-1">
          <S.MetricTitle>{title}</S.MetricTitle>
          <S.MetricValue>{value}</S.MetricValue>
          {subtitle && <S.MetricSubtitle>{subtitle}</S.MetricSubtitle>}
          {change && (
            <S.ChangeIndicator trend={change.trend}>
              <i
                className={`feather ${
                  change.trend === 'up'
                    ? 'icon-trending-up'
                    : change.trend === 'down'
                    ? 'icon-trending-down'
                    : 'icon-minus'
                }`}
              />
              <span>
                {change.trend !== 'stable' &&
                  `${change.value > 0 ? '+' : ''}${change.value}%`}
                {change.trend === 'stable' && 'Estável'} {change.period}
              </span>
            </S.ChangeIndicator>
          )}
        </div>
        {icon && (
          <S.MetricIcon color={color}>
            <i className={icon} />
          </S.MetricIcon>
        )}
      </div>
    </S.MetricCardContainer>
  )
}
